import FieldLayout from '../components/FieldLayout';
import { FieldWorkSettings } from '../components/field-work/FieldWorkSettings';
import { LetterheadSettings } from '../components/reports/LetterheadSettings';
import { isFieldReviewer } from '../components/field-work/api';
import { useAuth } from '../contexts/AuthContext';

export default function FieldWorkSettingsPage() {
  const { user } = useAuth();
  return <FieldLayout title="Field Work Settings">{isFieldReviewer(user) ? <div className="space-y-8"><LetterheadSettings /><FieldWorkSettings /></div> : <p role="alert" data-testid="field-settings-denied">Manager access required.</p>}</FieldLayout>;
}